"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
require("babylonjs-loaders");
var babylonjs_1 = require("babylonjs");
var const_1 = require("./util/const");
var colors_1 = require("./util/colors");
var vf_default_orbit_scene_1 = require("./vf-default-orbit-scene");
var vf_scene_builder_1 = require("./vf-scene-builder");
var vf_config_manager_1 = require("./util/vf-config-manager");
var vf_ego_camera_1 = require("./vf-ego-camera");
var logger_1 = require("./util/logger");
var VFDefaultOrbitSceneBuilder = (function (_super) {
    __extends(VFDefaultOrbitSceneBuilder, _super);
    function VFDefaultOrbitSceneBuilder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VFDefaultOrbitSceneBuilder.prototype.reset = function () {
        this.scene = new vf_default_orbit_scene_1.default(this.player);
    };
    VFDefaultOrbitSceneBuilder.prototype.addCamera = function () {
        var camera = new babylonjs_1.ArcRotateCamera("orbitCamera", 0, 0, 0, new babylonjs_1.Vector3(0, -1, 0), this.scene);
        camera.fov = babylonjs_1.Angle.FromDegrees(const_1.default.CAMERA_FOV).radians();
        camera.useFramingBehavior = true;
        camera.framingBehavior.mode = babylonjs_1.FramingBehavior.IgnoreBoundsSizeMode;
        camera.framingBehavior.autoCorrectCameraLimitsAndSensibility = true;
        camera.framingBehavior.elevationReturnTime = -1;
        camera.framingBehavior.zoomStopsAnimation = false;
        camera.minZ = const_1.default.CAMERA_MIN_Z;
        camera.maxZ = const_1.default.CAMERA_MAX_Z;
        camera.upperRadiusLimit = const_1.default.CAMERA_MAX_RADIUS;
        camera.lowerRadiusLimit = const_1.default.CAMERA_MIN_RADIUS;
        camera.upperBetaLimit = babylonjs_1.Angle.FromDegrees(const_1.default.CAMERA_MAX_BETA).radians();
        camera.pinchPrecision = const_1.default.CAMERA_PINCH_PRECISION;
        camera.pinchToPanMaxDistance = const_1.default.CAMERA_PINCH_PAN_DISTANCE;
        camera.angularSensibilityX = const_1.default.CAMERA_ANGULAR_SENSIBILITY;
        camera.angularSensibilityY = const_1.default.CAMERA_ANGULAR_SENSIBILITY;
        camera.wheelDeltaPercentage = const_1.default.CAMERA_WHEEL_PRECISION_DELTA;
        camera.panningAxis.set(1, 0, 1);
        camera.panningSensibility = const_1.default.CAMERA_PAN_SENSIBILITY;
        camera.attachControl(this.scene.getEngine().getRenderingCanvas());
        this.scene.camera = camera;
        var egoCamera = new vf_ego_camera_1.default("egoCamera", babylonjs_1.Vector3.Zero(), this.scene);
        egoCamera.setEnabled(false);
        egoCamera.inputs.clear();
        egoCamera.inputs.addMouse();
        egoCamera.fov = babylonjs_1.Angle.FromDegrees(const_1.default.EGO_CAMERA_FOV).radians();
        egoCamera.minZ = const_1.default.EGO_CAMERA_MIN_Z;
        egoCamera.maxZ = const_1.default.EGO_CAMERA_MAX_Z;
        egoCamera.angularSensibility = const_1.default.EGO_CAMERA_ANGULAR_SENSIBILITY * -1;
        this.scene.egoCamera = egoCamera;
        this.scene.registerBeforeRender(function () {
            egoCamera.applyLimits();
        });
    };
    VFDefaultOrbitSceneBuilder.prototype.addLightSetup = function () {
        var skyLight = new babylonjs_1.HemisphericLight("skylight", new babylonjs_1.Vector3(0, 1, 0), this.scene);
        var skyLightIntensity = vf_config_manager_1.default.GetConfig().skyLightIntensity;
        if (!this.player.expectsAuraWebFile) {
            skyLightIntensity *= 0.25;
        }
        skyLight.intensity = skyLightIntensity;
        skyLight.diffuse = colors_1.parseColorRGB(vf_config_manager_1.default.GetConfig().skyLightColor);
        skyLight.groundColor = this.calculateGroundColor();
        skyLight.specular = babylonjs_1.Color3.Black();
        var directionalLight = new babylonjs_1.DirectionalLight("sunlight", new babylonjs_1.Vector3(-0.5, -0.85, 0.5).scale(const_1.default.BASE_SCALE), this.scene);
        directionalLight.intensity = vf_config_manager_1.default.GetConfig().directionalLightIntensity;
        directionalLight.diffuse = colors_1.parseColorRGB(vf_config_manager_1.default.GetConfig().directionalLightColor);
        this.scene.light = directionalLight;
        if (vf_config_manager_1.default.GetConfig().enableShadows) {
            directionalLight.shadowEnabled = true;
            directionalLight.autoUpdateExtends = true;
            directionalLight.shadowMinZ = const_1.default.SHADOW_MIN_Z;
            directionalLight.shadowMaxZ = const_1.default.SHADOW_MAX_Z;
            var shadowGenerator = new babylonjs_1.ShadowGenerator(1024, directionalLight);
            shadowGenerator.usePercentageCloserFiltering = true;
            shadowGenerator.filteringQuality = babylonjs_1.ShadowGenerator.QUALITY_HIGH;
            shadowGenerator.bias = const_1.default.SHADOW_BIAS;
            shadowGenerator.darkness = const_1.default.SHADOW_DARKNESS;
            shadowGenerator.forceBackFacesOnly = true;
            this.scene.shadowGenerator = shadowGenerator;
        }
        if (vf_config_manager_1.default.GetConfig().enableAmbientOcclusion) {
            var ssao = new babylonjs_1.SSAORenderingPipeline("ssaopipeline", this.scene, {
                ssaoRatio: 1.0,
                combineRatio: 1.0,
            });
            ssao.fallOff = 0.000001;
            ssao.area = 1;
            ssao.radius = 0.0005;
            ssao.totalStrength = 0.85;
            ssao.base = 0.6;
            this.scene.postProcessRenderPipelineManager.attachCamerasToRenderPipeline("ssaopipeline", [
                this.scene.camera,
            ]);
        }
        this.scene.skylight = skyLight;
        var pipeline = new babylonjs_1.DefaultRenderingPipeline("defaultPipeline", true, this.scene, [this.scene.camera, this.scene.egoCamera]);
        pipeline.imageProcessingEnabled = false;
        if (this.player.config.antiAliasSamples > 0) {
            pipeline.fxaaEnabled = true;
            pipeline.samples = Math.min(this.player.config.antiAliasSamples, 8);
        }
        else {
            pipeline.fxaaEnabled = false;
            pipeline.samples = 0;
        }
        this.scene.imageProcessingConfiguration.toneMappingEnabled = false;
        logger_1.default.debug("Exposure: " + this.player.config.postProcessExposure);
        logger_1.default.debug("Contrast: " + this.player.config.postProcessContrast);
        if (this.player.config.postProcessExposure !== 1.0 || this.player.config.postProcessContrast !== 1.0) {
            this.scene.imageProcessingConfiguration.isEnabled = true;
            this.scene.imageProcessingConfiguration.contrast = this.player.config.postProcessContrast;
            this.scene.imageProcessingConfiguration.exposure = this.player.config.postProcessExposure;
        }
        else {
            this.scene.imageProcessingConfiguration.isEnabled = false;
            this.scene.imageProcessingConfiguration.contrast = 1.0;
            this.scene.imageProcessingConfiguration.exposure = 1.0;
        }
    };
    VFDefaultOrbitSceneBuilder.prototype.addEnvironment = function (enableMirror) {
        if (enableMirror === void 0) { enableMirror = false; }
        var environmentSettings = {
            createGround: enableMirror === false,
            createSkybox: false,
            enableGroundShadow: true,
            sizeAuto: true,
            groundColor: this.calculateGroundColor(),
        };
        if (vf_config_manager_1.default.GetConfig().environmentMapURL) {
            try {
                var envTexture = new babylonjs_1.CubeTexture(vf_config_manager_1.default.GetConfig().environmentMapURL, this.scene);
                environmentSettings["environmentTexture"] = envTexture;
            }
            catch (error) {
                logger_1.default.warn("failed to load the specified environment map");
            }
        }
        if (vf_config_manager_1.default.GetConfig().groundTextureURL) {
            try {
                var groundTexture = new babylonjs_1.Texture(vf_config_manager_1.default.GetConfig().groundTextureURL, this.scene);
                groundTexture.hasAlpha = true;
                environmentSettings["groundTexture"] = groundTexture;
            }
            catch (error) {
                logger_1.default.warn("failed to load the specified ground texture");
            }
        }
        var environment3D = this.scene.createDefaultEnvironment(environmentSettings);
        if (enableMirror) {
            var relativeSize = 25;
            var ground = babylonjs_1.Mesh.CreateGround("ground", relativeSize, relativeSize, 2, this.scene);
            ground.receiveShadows = true;
            ground.alphaIndex = 0;
            ground.isPickable = false;
            var backgroundMaterial = new babylonjs_1.BackgroundMaterial("backgroundMaterial", this.scene);
            backgroundMaterial.diffuseTexture = new babylonjs_1.Texture("https://assets.babylonjs.com/environments/backgroundGround.png", this.scene);
            backgroundMaterial.diffuseTexture.hasAlpha = true;
            backgroundMaterial.opacityFresnel = false;
            backgroundMaterial.shadowLevel = 0.4;
            backgroundMaterial.zOffset = 10;
            var mirror = new babylonjs_1.MirrorTexture("mirror", 1024, this.scene);
            mirror.mirrorPlane = new babylonjs_1.Plane(0, -1, 0, 0);
            backgroundMaterial.reflectionTexture = mirror;
            backgroundMaterial.reflectionFresnel = true;
            backgroundMaterial.reflectionStandardFresnelWeight = 0.7;
            ground.material = backgroundMaterial;
            this.scene.groundMirror = ground;
            this.scene.mirrorTexture = mirror;
        }
        else {
            environment3D.ground.scaling.scaleInPlace(const_1.default.GROUND_SCALE);
            environment3D.ground.alphaIndex = 0;
            environment3D.groundMaterial.zOffset = 10;
            environment3D.ground.isPickable = false;
        }
        this.scene.environment = environment3D;
    };
    VFDefaultOrbitSceneBuilder.prototype.calculateGroundColor = function () {
        if (vf_config_manager_1.default.GetConfig().groundColor) {
            return colors_1.parseColorRGB(vf_config_manager_1.default.GetConfig().groundColor);
        }
        else {
            return colors_1.darkenColorRGB(vf_config_manager_1.default.GetConfig().sceneClearColor, const_1.default.GROUND_DARKEN_FACTOR);
        }
    };
    return VFDefaultOrbitSceneBuilder;
}(vf_scene_builder_1.default));
exports.default = VFDefaultOrbitSceneBuilder;
